const REFRESH_KEY = 'nexus.refreshToken'
const DISPLAY_NAME_KEY = 'nexus.displayName'
const REMEMBER_KEY = 'nexus.rememberMe'

let accessToken: string | null = null

function preferredStorage(): Storage {
  return getRememberMe() ? localStorage : sessionStorage
}

function safeGet(storage: Storage, key: string): string | null {
  try {
    return storage.getItem(key)
  } catch {
    return null
  }
}

function safeRemove(storage: Storage, key: string): void {
  try {
    storage.removeItem(key)
  } catch {
    // ignore
  }
}

export function getRememberMe(): boolean {
  return safeGet(localStorage, REMEMBER_KEY) === 'true'
}

export function setRememberMe(value: boolean): void {
  try {
    if (value) localStorage.setItem(REMEMBER_KEY, 'true')
    else localStorage.removeItem(REMEMBER_KEY)
  } catch {
    // ignore
  }
}

export function getAccessToken(): string | null {
  return accessToken
}

export function setAccessToken(token: string | null): void {
  accessToken = token
}

export function getRefreshToken(): string | null {
  return safeGet(localStorage, REFRESH_KEY) || safeGet(sessionStorage, REFRESH_KEY)
}

export function setRefreshToken(token: string | null): void {
  safeRemove(localStorage, REFRESH_KEY)
  safeRemove(sessionStorage, REFRESH_KEY)
  if (!token) return
  try {
    preferredStorage().setItem(REFRESH_KEY, token)
  } catch {
    // storage unavailable
  }
}

export function setDisplayName(name: string | null): void {
  safeRemove(localStorage, DISPLAY_NAME_KEY)
  safeRemove(sessionStorage, DISPLAY_NAME_KEY)
  if (!name) return
  try {
    preferredStorage().setItem(DISPLAY_NAME_KEY, name)
  } catch {
    // storage unavailable
  }
}

export function clearTokens(): void {
  accessToken = null
  safeRemove(localStorage, REFRESH_KEY)
  safeRemove(sessionStorage, REFRESH_KEY)
  safeRemove(localStorage, DISPLAY_NAME_KEY)
  safeRemove(sessionStorage, DISPLAY_NAME_KEY)
}
